import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireSystemAdmin } from '~/utils/guards';

/** Workflow Console is super-admin only — the guard redirects everyone else. */
export const Route = createFileRoute('/_authenticated/_tenant/workflow-runs')({
  beforeLoad: requireSystemAdmin(),
  component: () => <Outlet />,
});
